import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavDrawer } from './NavDrawer';
import { AnnouncementBar } from './AnnouncementBar';
import { StickyBuyBar, STICKY_BAR_ROUTES } from '../shop/StickyBuyBar';
import { PreCheckoutSheet } from '../checkout/PreCheckoutSheet';
import { NavDrawerProvider } from '../../contexts/NavDrawerContext';
import { initMetaPixel, track } from '../../utils/analytics';
import { sendShopifyPageView, shopifyAnalyticsEnabled } from '../../utils/shopifyAnalytics';
import { ShopifyCookies } from '../analytics/ShopifyCookies';
export function SiteLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
    track('page_view', {
      path: pathname
    });
    sendShopifyPageView(pathname);
  }, [pathname]);
  return <NavDrawerProvider data-id="element-499" data-mp="2z8kbdho9jsw9">
      {shopifyAnalyticsEnabled() && <ShopifyCookies data-id="element-500" data-mp="1add9mwbjwec6" />}
      <div className="flex min-h-screen w-full flex-col bg-deep text-white" data-id="element-501" data-mp="1ac2axawypwrx">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-marine focus:px-4 focus:py-2" data-id="element-502" data-mp="1fb54nz7hsgkl">
          Skip to content
        </a>
        <AnnouncementBar data-id="element-503" data-mp="1o3qlvavh6f7b" />
        <Header data-id="element-504" data-mp="1o630be20y7fm" />
        <main id="main" className="flex-1" data-id="element-505" data-mp="re95a0uyf8qu">
          <Outlet data-id="element-506" data-mp="rfar90didfnc" />
        </main>
        <Footer data-id="element-507" data-mp="rgc51clwsg8r" />
        {/* Room for the mobile sticky purchase bar so it never covers the footer. */}
        {STICKY_BAR_ROUTES.includes(pathname) && <div className="h-[88px] bg-[#050F1C] lg:hidden" aria-hidden data-id="element-508" data-mp="10eeac4codv1u" />}
        <StickyBuyBar data-id="element-509" data-mp="15dimn3uwc8we" />
        <NavDrawer data-id="element-510" data-mp="15e0p4i85jjcr" />
        <PreCheckoutSheet data-id="element-511" data-mp="15ek17ib4fdiv" />
      </div>
    </NavDrawerProvider>;
}